<template>
  <v-container id="user-profile" fluid tag="section">
    <v-row justify="center">
      <v-col cols="12" lg="12" md="12">
        <base-material-card
          icon="mdi-domain"
          :title="
            id
              ? $i18n.t('Edit Integration')
              : $i18n.t('Add Integration')
          "
          class="px-3 py-1 small-icon"
        >
          <v-form id="form" v-model="isValid">
            <v-row>
              <v-col cols="12" sm="12" md="12" lg="12">
                <v-container class="py-0">
                  <v-row>
                    <v-col cols="12" sm="12" md="6" lg="3">
                      <z-client-select
                        :rules="validationrules.client"
                        required
                        withSelf="true"
                        class="purple-input"
                        v-model="integration.client_id"
                      ></z-client-select>
                    </v-col>

                    <v-col cols="12" sm="12" md="6" lg="3">
                      <z-vendor-select
                        :label="$i18n.t('Vendor')"
                        :rules="validationrules.vendor"
                        required
                        withSelf="true"
                        class="purple-input"
                        v-model="integration.vendor_id"
                      ></z-vendor-select>
                    </v-col>

                    <v-col cols="12" sm="12" md="6" lg="3">
                      <v-select
                        :label="$i18n.t('Integration Type')"
                        class="purple-input"
                        :items="kindList"
                        item-text="name"
                        item-value="value"
                        v-model="integration.kind"
                        :rules="validationrules.kind"
                        required
                        :disabled="id != null"
                      ></v-select>
                    </v-col>

                    <v-col cols="12" sm="12" md="6" lg="3">
                      <v-select
                        :label="$i18n.t('For Users')"
                        class="purple-input"
                        :items="forUserList"
                        item-text="name"
                        item-value="value"
                        v-model="integration.forKind"
                        :rules="validationrules.forKind"
                        required
                      ></v-select>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col>
                      <v-checkbox
                        v-model="integration.isDev"
                        :label="$i18n.t('For Development Purpose')"
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                </v-container>

                <!-- Zoyride Configuration Start-->
                <v-container v-if="integration.kind == 1">
                  <h3>Zoyride Configuration</h3>
                  <v-row>
                    <v-col>
                      <v-text-field
                        :label="$i18n.t('Client Id')"
                        class="purple-input"
                        v-model="integration.zConfig.clientId"
                        :rules="validationrules.z_ClientID"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col>
                      <v-text-field
                        :label="$i18n.t('Secret')"
                        class="purple-input"
                        v-model="integration.zConfig.secret"
                        :rules="validationrules.z_Secret"
                        required
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-text-field
                        :label="$i18n.t('My Client Id')"
                        class="purple-input"
                        v-model="integration.zConfig.myClientId"
                        :rules="validationrules.z_mClientID"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col>
                      <v-text-field
                        :label="$i18n.t('My Secret')"
                        class="purple-input"
                        v-model="integration.zConfig.mySecret"
                        :rules="validationrules.z_mSecret"
                        required
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-text-field
                        :label="$i18n.t('Sync URL')"
                        class="purple-input"
                        v-model="integration.zConfig.syncUrl"
                        :rules="validationrules.z_sURL"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col>
                      <v-text-field
                        :label="$i18n.t('Rates URL')"
                        class="purple-input"
                        v-model="integration.zConfig.ratesUrl"
                        :rules="validationrules.z_rURL"
                        required
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
                <!-- Zoyride Configuration End-->

                <!-- Tarvelogixx Configuration Start-->
                <v-container v-if="integration.kind == 2">
                  <h3>Travelogixx Configuration</h3>
                  <v-row>
                    <v-col>
                      <v-text-field
                        :label="$i18n.t('User Id')"
                        class="purple-input"
                        v-model="integration.tlConfig.userID"
                        :rules="validationrules.tl_userID"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col>
                      <v-text-field
                        :label="$i18n.t('Client Id')"
                        class="purple-input"
                        v-model="integration.tlConfig.clientID"
                        :rules="validationrules.tl_clientID"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col>
                      <v-text-field
                        :label="$i18n.t('Password')"
                        class="purple-input"
                        v-model="integration.tlConfig.password"
                        :rules="validationrules.tl_password"
                        required
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col>
                      <v-text-field
                        :label="$i18n.t('Client Language')"
                        class="purple-input"
                        v-model="integration.tlConfig.clientLanguage"
                        :rules="validationrules.tl_cLang"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col>
                      <v-text-field
                        :label="$i18n.t('Client Market')"
                        class="purple-input"
                        v-model="integration.tlConfig.clientMarket"
                        :rules="validationrules.tl_cMarket"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col>
                      <v-text-field
                        :label="$i18n.t('Client Type')"
                        class="purple-input"
                        v-model="integration.tlConfig.clientType"
                        :rules="validationrules.tl_cType"
                        required
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col>
                      <v-text-field
                        :label="$i18n.t('Client Nationality')"
                        class="purple-input"
                        v-model="integration.tlConfig.clientNationality"
                        :rules="validationrules.tl_cNationality"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col>
                      <v-text-field
                        :label="$i18n.t('Point Of Sale')"
                        class="purple-input"
                        v-model="integration.tlConfig.pointOfSale"
                        :rules="validationrules.tl_pSale"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col>
                      <v-text-field
                        :label="$i18n.t('Client IATA Number')"
                        class="purple-input"
                        v-model="integration.tlConfig.clientIATANumber"
                        :rules="validationrules.tl_cIATANo"
                        required
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col>
                      <v-text-field
                        :label="$i18n.t('Client Call-back URL')"
                        class="purple-input"
                        v-model="integration.tlConfig.clientCallbackAddress"
                        :rules="validationrules.tl_cAddress"
                        required
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col>
                      <v-text-field
                        :label="$i18n.t('Search URL')"
                        class="purple-input"
                        v-model="integration.tlConfig.searchUrl"
                        :rules="validationrules.tl_sURL"
                        required
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col>
                      <v-text-field
                        :label="$i18n.t('Book URL')"
                        class="purple-input"
                        v-model="integration.tlConfig.bookUrl"
                        :rules="validationrules.tl_bURL"
                        required
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col>
                      <v-text-field
                        :label="$i18n.t('Get Detail URL')"
                        class="purple-input"
                        v-model="integration.tlConfig.detailUrl"
                        :rules="validationrules.tl_dURL"
                        required
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col>
                      <v-text-field
                        :label="$i18n.t('Amend URL')"
                        class="purple-input"
                        v-model="integration.tlConfig.amendUrl"
                        :rules="validationrules.tl_aURL"
                        required
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col>
                      <v-text-field
                        :label="$i18n.t('Cancel URL')"
                        class="purple-input"
                        v-model="integration.tlConfig.cancelUrl"
                        :rules="validationrules.tl_cURL"
                        required
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
                <!-- Tarvelogixx Configuration End-->

                <!-- Europe Car Configuration Start-->
                <v-container v-if="integration.kind == 4">
                  <h3>Europe Car Configuration</h3>
                  <v-row>
                    <v-col>
                      <v-text-field
                        :label="$i18n.t('End Point')"
                        class="purple-input"
                        v-model="integration.ecConfig.endPoint"
                        :rules="validationrules.ec_ePoint"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col>
                      <v-text-field
                        :label="$i18n.t('Caller Code')"
                        class="purple-input"
                        v-model="integration.ecConfig.callerCode"
                        :rules="validationrules.ec_cCode"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col>
                      <v-text-field
                        :label="$i18n.t('Password')"
                        class="purple-input"
                        v-model="integration.ecConfig.password"
                        :rules="validationrules.ec_pass"
                        required
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col>
                      <v-text-field
                        :label="$i18n.t('IATA')"
                        class="purple-input"
                        v-model="integration.ecConfig.IATA"
                        :rules="validationrules.ec_IATA"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col>
                      <v-text-field
                        :label="$i18n.t('Contract ID')"
                        class="purple-input"
                        v-model="integration.ecConfig.contractID"
                        :rules="validationrules.ec_cID"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col>
                      <v-text-field
                        :label="$i18n.t('ORG ID')"
                        class="purple-input"
                        v-model="integration.ecConfig.orgID"
                        :rules="validationrules.ec_orgID"
                        required
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col>
                      <v-text-field
                        :label="$i18n.t('Business Account No')"
                        class="purple-input"
                        v-model="integration.ecConfig.businessAccountNo"
                        :rules="validationrules.ec_bAccNo"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col>
                      <v-text-field
                        :label="$i18n.t('Type Code')"
                        class="purple-input"
                        v-model="integration.ecConfig.typeCode"
                        :rules="validationrules.ec_tCode"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col>
                      <v-text-field
                        :label="$i18n.t('Mope Code')"
                        class="purple-input"
                        v-model="integration.ecConfig.mopCode"
                        :rules="validationrules.ec_mCode"
                        required
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col>
                      <v-text-field
                        :label="$i18n.t('Prepaid Mode')"
                        class="purple-input"
                        v-model="integration.ecConfig.prepaidMode"
                        :rules="validationrules.ec_pMode"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col>
                      <v-text-field
                        :label="$i18n.t('Car Type')"
                        class="purple-input"
                        v-model="integration.ecConfig.carType"
                        :rules="validationrules.ec_cType"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col>
                      <v-text-field
                        :label="$i18n.t('Type (For C Contract ID is mandatory.)')"
                        class="purple-input"
                        v-model="integration.ecConfig.type"
                        :rules="validationrules.ec_type"
                        required
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
                <!-- Europe Car Configuration End-->

                <v-container v-if="integration.kind === 2 || integration.kind === 4">
                  <h3>
                    City Codes
                    <v-btn
                      small
                      class="float-right"
                      color="grey"
                      light
                      @click="showCityCodes = !showCityCodes"
                    >
                      <v-icon>remove_red_eye</v-icon>
                      {{showCityCodes ? 'Hide City Codes' : 'Show City Codes'}}
                    </v-btn>

                    <v-btn
                      small
                      class="float-right"
                      color="primary"
                      light
                      @click.stop="cityCodeDialog = true"
                    >Add</v-btn>
                  </h3>
                  <v-row>
                    <v-col></v-col>
                  </v-row>

                  <v-card v-if="showCityCodes">
                    <v-simple-table dense style="padding: 10px">
                      <thead>
                        <tr>
                          <th class="primary--text">{{ $i18n.t("Country") }}</th>
                          <th class="primary--text">{{ $i18n.t("Country Code") }}</th>
                          <th class="primary--text">{{ $i18n.t("City") }}</th>
                          <th class="primary--text">{{ $i18n.t("City Code") }}</th>
                          <th class="text-right primary--text"></th>
                        </tr>
                      </thead>

                      <tbody v-if="integration.tlConfig">
                        <tr
                          v-for="(c_code, index) in integration.tlConfig.cityCodes"
                          :key="c_code._id"
                        >
                          <td>{{c_code.country}}</td>
                          <td>{{c_code.countryCode}}</td>
                          <td>{{c_code.city}}</td>
                          <td>{{c_code.code}}</td>
                          <td>
                            <v-btn
                              class="float-right"
                              color="error"
                              small
                              fab
                              text
                              dark
                              @click="remove(index, 2)"
                            >
                              <v-icon>mdi-trash-can-outline</v-icon>
                            </v-btn>
                          </td>
                        </tr>
                        <v-spacer></v-spacer>
                      </tbody>

                      <tbody v-if="integration.ecConfig">
                        <tr
                          v-for="(c_code, index) in integration.ecConfig.cityCodes"
                          :key="c_code._id"
                        >
                          <td>{{c_code.country}}</td>
                          <td>{{c_code.countryCode}}</td>
                          <td>{{c_code.city}}</td>
                          <td>{{c_code.code}}</td>
                          <td>
                            <v-btn
                              class="float-right"
                              color="error"
                              small
                              fab
                              text
                              dark
                              @click="remove(index, 4)"
                            >
                              <v-icon>mdi-trash-can-outline</v-icon>
                            </v-btn>
                          </td>
                        </tr>
                        <v-spacer></v-spacer>
                      </tbody>
                    </v-simple-table>
                  </v-card>
                </v-container>

                <v-container>
                  <h3>Policy</h3>
                  <v-row>
                    <v-col>
                      <vue-editor v-model="integration.policy"></vue-editor>
                    </v-col>
                  </v-row>
                </v-container>
              </v-col>
            </v-row>
            <v-row style="padding: 0 20px 10px">
              <v-btn small fab :to="'/integrations'">
                <v-icon>mdi-arrow-left</v-icon>
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn
                color="success"
                class="mr-0"
                @click="save()"
                :loading="loading"
                :disabled="!isValid"
              >
                <h3>{{ $i18n.t("Save") }}</h3>
              </v-btn>
            </v-row>
          </v-form>
        </base-material-card>
      </v-col>

      <v-dialog v-model="cityCodeDialog" max-width="1000">
        <v-form id="cityCodeForm" v-model="isAddCodeValid">
          <v-card>
            <v-card-title class="headline">Add city code</v-card-title>
            <v-col>
              <v-card-actions>
                <v-row>
                  <v-col cols="12" sm="12" md="6" lg="3">
                    <z-country-select
                      class="purple-input"
                      v-model="cityCode.country"
                      :rules="validationrules.d_country"
                      required
                    ></z-country-select>
                  </v-col>
                  <v-col cols="12" sm="12" md="6" lg="3">
                    <v-text-field
                      :label="$i18n.t('Country Code')"
                      class="purple-input"
                      v-model="cityCode.countryCode"
                      :rules="validationrules.d_CC"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="6" lg="3">
                    <z-city-select
                      :country="cityCode.country"
                      class="purple-input"
                      v-model="cityCode.city"
                      :rules="validationrules.d_city"
                      required
                    ></z-city-select>
                  </v-col>
                  <v-col cols="12" sm="12" md="6" lg="3">
                    <v-text-field
                      :label="$i18n.t('City Code')"
                      class="purple-input"
                      v-model="cityCode.code"
                      :rules="validationrules.d_code"
                      required
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-card-actions>
            </v-col>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="grey" fab small text @click="cityCodeDialog = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>

              <v-btn color="green" @click="addCityCode" :disabled="!isAddCodeValid">Submit</v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>
    </v-row>
  </v-container>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";
import { doGet, doPost } from "@/store/common/module/apis";
import common from "@/store/common/module/common";
import { VueEditor } from "vue2-editor";

@Component({
  components: {
    VueEditor,
  },
})
export default class IntegrationEdit extends Vue {
  isValid = true;
  isAddCodeValid = true;
  cityCodeDialog = false;
  showCityCodes = false;
  integration = {
    _id: null,
    client_id: "",
    vendor_id: "",
    kind: "",
    forKind: "",
    isDev: null,
    zConfig: {
      clientId: "",
      secret: "",
      myClientId: "",
      mySecret: "",
      syncUrl: "",
      ratesUrl: "",
    },
    tlConfig: {
      userID: "",
      clientID: "",
      password: "",
      clientLanguage: "",
      clientMarket: "",
      clientType: "",
      clientNationality: "",
      pointOfSale: "",
      clientIATANumber: "",
      clientCallbackAddress: "",
      searchUrl: "",
      bookUrl: "",
      detailUrl: "",
      amendUrl: "",
      cancelUrl: "",
    },
    ecConfig: {
      endPoint: "",
      callerCode: "",
      password: "",
      IATA: "",
      contractID: "",
      orgID: "",
      businessAccountNo: "",
      typeCode: "",
      mopCode: "",
      prepaidMode: "",
      carType: "",
      type: "",
    },
  };

  kindList = [
    {
      name: "Zoyride",
      value: 1,
    },
    {
      name: "Travelogixx (Ezeego1)",
      value: 2,
    },
    {
      name: "CKIS",
      value: 3,
    },
    {
      name: "Europe Car",
      value: 4,
    },
  ];

  forUserList = [
    {
      name: "Direct Customer",
      value: 1,
    },
    {
      name: "B2B Customer",
      value: 2,
    },
    {
      name: "Both Direct and B2B Customer",
      value: 3,
    },
  ];

  cityCode = {
    country: "",
    countryCode: "",
    city: "",
    code: "",
  };

  validationrules = {
    client: [(v) => !!v || this.$i18n.t("Client is required")],
    vendor: [(v) => !!v || this.$i18n.t("Vendor is required")],
    kind: [(v) => !!v || this.$i18n.t("Integration type is required")],
    forKind: [(v) => !!v || this.$i18n.t("For User is required")],
    z_ClientID: [
      (v) =>
        (!!v && this.integration.kind != 1) ||
        this.$i18n.t("Client ID is required"),
    ],
    z_Secret: [
      (v) =>
        (!!v && this.integration.kind != 1) ||
        this.$i18n.t("Secret key is required"),
    ],
    z_mClientID: [
      (v) =>
        (!!v && this.integration.kind != 1) ||
        this.$i18n.t("My Client ID is required"),
    ],
    z_mSecret: [
      (v) =>
        (!!v && this.integration.kind != 1) ||
        this.$i18n.t("My Secret is required"),
    ],
    z_sURL: [
      (v) =>
        (!!v && this.integration.kind != 1) ||
        this.$i18n.t("Sync URL is required"),
    ],
    z_rURL: [
      (v) =>
        (!!v && this.integration.kind != 1) ||
        this.$i18n.t("Rates URL is required"),
    ],
    tl_userID: [
      (v) =>
        (!!v && this.integration.kind != 2) ||
        this.$i18n.t("User ID is required"),
    ],
    tl_clientID: [
      (v) =>
        (!!v && this.integration.kind != 2) ||
        this.$i18n.t("Client ID is required"),
    ],
    tl_password: [
      (v) =>
        (!!v && this.integration.kind != 2) ||
        this.$i18n.t("Password is required"),
    ],
    tl_cLang: [
      (v) =>
        (!!v && this.integration.kind != 2) ||
        this.$i18n.t("Client language is required"),
    ],
    tl_cMarket: [
      (v) =>
        (!!v && this.integration.kind != 2) ||
        this.$i18n.t("Client market is required"),
    ],
    tl_cType: [
      (v) =>
        (!!v && this.integration.kind != 2) ||
        this.$i18n.t("Client type is required"),
    ],
    tl_cNationality: [
      (v) =>
        (!!v && this.integration.kind != 2) ||
        this.$i18n.t("Client nationality is required"),
    ],
    tl_pSale: [
      (v) =>
        (!!v && this.integration.kind != 2) ||
        this.$i18n.t("Point of sale is required"),
    ],
    tl_cIATANo: [
      (v) =>
        (!!v && this.integration.kind != 2) ||
        this.$i18n.t("Client IATA number is required"),
    ],
    tl_cAddress: [
      (v) =>
        (!!v && this.integration.kind != 2) ||
        this.$i18n.t("Client callback URL is required"),
    ],
    tl_sURL: [
      (v) =>
        (!!v && this.integration.kind != 2) ||
        this.$i18n.t("Search URL is required"),
    ],
    tl_bURL: [
      (v) =>
        (!!v && this.integration.kind != 2) ||
        this.$i18n.t("Book URL is required"),
    ],
    tl_dURL: [
      (v) =>
        (!!v && this.integration.kind != 2) ||
        this.$i18n.t("Detail URL is required"),
    ],
    tl_aURL: [
      (v) =>
        (!!v && this.integration.kind != 2) ||
        this.$i18n.t("Amend URL is required"),
    ],
    tl_cURL: [
      (v) =>
        (!!v && this.integration.kind != 2) ||
        this.$i18n.t("Cancel URL is required"),
    ],
    ec_ePoint: [
      (v) =>
        (!!v && this.integration.kind != 4) ||
        this.$i18n.t("End point is required"),
    ],
    ec_cCode: [
      (v) =>
        (!!v && this.integration.kind != 4) ||
        this.$i18n.t("Caller code is required"),
    ],
    ec_pass: [
      (v) =>
        (!!v && this.integration.kind != 4) ||
        this.$i18n.t("Password is required"),
    ],
    ec_IATA: [
      (v) =>
        (!!v && this.integration.kind != 4) || this.$i18n.t("IATA is required"),
    ],
    ec_bAccNo: [
      (v) =>
        (!!v && this.integration.kind != 4) ||
        this.$i18n.t("Business account no. is required"),
    ],
    ec_tCode: [
      (v) =>
        (!!v && this.integration.kind != 4) ||
        this.$i18n.t("Type code is required"),
    ],
    ec_mCode: [
      (v) =>
        (!!v && this.integration.kind != 4) ||
        this.$i18n.t("Mope code is required"),
    ],
    ec_pMode: [
      (v) =>
        (!!v && this.integration.kind != 4) ||
        this.$i18n.t("Prepaid mode is required"),
    ],
    d_country: [(v) => !!v || this.$i18n.t("Country is required")],
    d_CC: [(v) => !!v || this.$i18n.t("Country Code is required")],
    d_city: [(v) => !!v || this.$i18n.t("City is required")],
    d_code: [(v) => !!v || this.$i18n.t("City Code is required")],
  };

  id = null;

  get loading() {
    return common.loading;
  }

  remove(_index, type) {
    if (type == 2) {
      this.integration.tlConfig.cityCodes.splice(_index, 1);
    } else if (type == 4) {
      this.integration.ecConfig.cityCodes.splice(_index, 1);
    }
  }

  //   add() {
  //     if (this.integration.holidays == null) {
  //       this.holiday.holidays = [];
  //     }
  //     this.holiday.holidays.push({
  //       _id: null,
  //       name: "",
  //       description: "",
  //       year: "",
  //       country: "",
  //       holidays: []
  //     });
  //   }

  addCityCode() {
    if (this.integration.kind == 2) {
      if (!this.integration.tlConfig) {
        this.integration.tlConfig = {};
      }
      if (!this.integration.tlConfig.cityCodes) {
        this.integration.tlConfig.cityCodes = [];
      }
      if (this.cityCode) {
        this.integration.tlConfig.cityCodes.push(this.cityCode);
      }
      this.cityCodeDialog = false;
    } else if (this.integration.kind == 4) {
      if (!this.integration.ecConfig) {
        this.integration.ecConfig = {};
      }
      if (!this.integration.ecConfig.cityCodes) {
        this.integration.ecConfig.cityCodes = [];
      }
      if (this.cityCode) {
        this.integration.ecConfig.cityCodes.push(this.cityCode);
      }
      this.cityCodeDialog = false;
    }
  }

  createNew() {
    window.location.href = "/integration/create";
  }

  async save() {
    try {
      common.setLoading(true);
      let postUrl = "/api/outlander/config/save";
      if (this.integration._id) {
        postUrl = "/api/outlander/config/" + this.integration._id + "/update";
      }
      this.integration = await doPost(postUrl, this.integration);
      common.setLoading(false);
      common.showMessage("Saved Successfully");
      window.location.href = "/integration/" + this.integration._id;
    } catch (e) {
      common.setError(e.message);
      common.setLoading(false);
    }
  }

  async get(id) {
    try {
      this.integration = await doGet("/api/outlander/config/" + id + "/detail");
      if (this.integration._id != null) {
        this.id = this.integration._id;
      }
    } catch (e) {
      common.setError(e.message);
    }
  }

  async mounted() {
    if (this.$route.params.id) {
      await this.get(this.$route.params.id);
    }
  }
}
</script>
